// Text for the Claude connection screens. Pure, so it is tested without a browser.

export interface ClaudeConnectionRow {
  id: string;
  kind: "connector" | "personal";
  label: string;
  prefix: string;
  createdAt: string;
  lastUsedAt: string | null;
  expiresAt: string | null;
  userId: string;
  userName: string;
}

export const MCP_URL = "https://ftccrm.com/mcp";

/** The block Claude Code reads from ~/.claude.json. */
export function claudeCodeConfig(key: string, url = MCP_URL): string {
  return JSON.stringify(
    { mcpServers: { "ftc-crm": { type: "http", url, headers: { Authorization: `Bearer ${key}` } } } },
    null,
    2,
  );
}

export function kindLabel(kind: ClaudeConnectionRow["kind"]): string {
  return kind === "connector" ? "Cowork / claude.ai" : "Personal key";
}

export function lastUsedLabel(iso: string | null, now = new Date()): string {
  if (!iso) return "Never used";
  const mins = Math.floor((now.getTime() - new Date(iso).getTime()) / 60_000);
  if (mins < 5) return "Used just now";
  if (mins < 60) return `Used ${mins} min ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `Used ${hrs} hr ago`;
  const days = Math.floor(hrs / 24);
  return `Used ${days} day${days === 1 ? "" : "s"} ago`;
}
